export const hy = {
  title: 'Առաջնային անտառներ',
  subtitle: '30մ, արևադարձային, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Գործառույթ',
      value:
        'Տվյալների այս հավաքածուն քարտեզագրում է 2001 թվականին համաշխարհային համաարևադարձային շրջաններում առաջնային անտառների տարածությունը:',
    },
    {
      label: 'Բանաձեւ',
      value: '30 × 30 մետր',
    },
    {
      label: 'Աշխարհագրական ծածկույթ',
      value: 'Պան-Տրոպիկական',
    },
    {
      label: 'Աղբյուր',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Անտառների շարունակական առաջնային կորուստ Բրազիլիայում, Կոնգոյի Դեմոկրատական ​​Հանրապետությունում և Ինդոնեզիայում: Environmental Research Letters, 13(7), p.074028:',
    },
    {
      label: 'Բովանդակության ամսաթիվը',
      value: 2001,
    },
  ],
  overview: {
    label: 'Ընդհանուր ակնարկ',
    value:
      'Առաջնային անտառները կենսաբազմազան անտառներից են, որոնք ապահովում են բազմաթիվ էկոհամակարգային ծառայություններ, ինչը նրանց կարևոր է դարձնում ազգային հողօգտագործման պլանավորման և ածխածնային հաշվառման համար մոնիտորինգի համար: Տվյալների այս հավաքածուն սահմանում է առաջնային անտառները որպես «հասուն բնական խոնավ արևադարձային անտառածածկ, որն ամբողջությամբ չի մաքրվել և վերաաճել նորագույն պատմության ընթացքում»: Հետազոտողները դասակարգել են Landsat-ի պատկերները անտառների առաջնային տվյալների մեջ՝ օգտագործելով առանձին ալգորիթմ յուրաքանչյուր տարածաշրջանի համար:',
  },
  citation: {
    label: 'Մեջբերում',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Անտառների շարունակական առաջնային կորուստ Բրազիլիայում, Կոնգոյի Դեմոկրատական ​​Հանրապետությունում և Ինդոնեզիայում: Environmental Research Letters, 13(7), p.074028: Մուտք գործվել է Global Forest Watch-ի միջոցով 31/01/2025-ին: www.globalforestwatch.org.',
  },
};
